import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';
import { Flow } from '../models/flows.model';

export const InitFlowTableColumns = createAction(
  '[Flows: Flow Configuration]: Init Flow Table Columns',
  props<{ displayedColumns: { [key: string]: string } }>(),
);

export const GetFlowEventsSuccess = createAction(
  '[Flows: Flow Configuration]: Get Flow Events Success',
  props<{ res: QcResponseGrid }>(),
);

export const GetFlowEventsFailed = createAction(
  '[Flows: Flow Configuration]: Get Flow Events Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ContextFlowChanged = createAction(
  '[Flows: Flow Configuration]: Context Flow Changed',
  props<{ contextFlow: string }>(),
);

export const GetContextFlowSuccess = createAction(
  '[Flows: Flow Configuration]: Get Context Flow Success',
  props<{ res: QcResponseGrid }>(),
);

export const GetContextFlowFailed = createAction(
  '[Flows: Flow Configuration]: Get Context Flow Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const FlowEventChanged = createAction(
  '[Flows: Flow Configuration]: Flow Event Changed',
  props<{ flowEvent: string }>(),
);

export const GetFlowEventSuccess = createAction(
  '[Flows: Flow Configuration]: Get Flow Event Success',
  props<{ res: Flow[] }>(),
);

export const GetFlowEventFailed = createAction(
  '[Flows: Flow Configuration]: Get Flow Event Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetFlowTableSuccess = createAction(
  '[Flows: Flow Configuration]: Get Flow Table Success',
  props<{ res: QcResponse }>(),
);

export const GetFlowTableFailed = createAction(
  '[Flows: Flow Configuration]: Get Flow Table Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const FlowStatusChanged = createAction(
  '[Flows: Flow Configuration]: Flow Status Changed',
  props<{ index: number }>(),
);

export const FlowStartDateChanged = createAction(
  '[Flows: Flow Configuration]: Flow Start Date Changed',
  props<{ activeFrom: string; index: number }>(),
);

export const FlowEndDateChanged = createAction(
  '[Flows: Flow Configuration]: Flow End Date Changed',
  props<{ activeUntil: string; index: number }>(),
);

export const DeleteFlow = createAction(
  '[Flows: Flow Configuration]: Flow Deleted',
  props<{ index: number }>(),
);

export const ReorderFlowTable = createAction(
  '[Flows: Flow Configuration]: Reorder Flow Table',
  props<{ previousIndex: number; currentIndex: number }>(),
);

export const EnableRowDrag = createAction('[Flows: Flow Configuration]: Enable Row Drag');

export const DisableRowDrag = createAction('[Flows: Flow Configuration]: Disable Row Drag');

export const AddFlow = createAction(
  '[Flows: Flow Configuration]: Add Flow',
  props<{ flowID: string; currDate: string }>(),
);

export const UpdateConfiguration = createAction(
  '[Flows: Flow Configuration]: Update Configuration',
);

export const UpdateConfigurationSuccess = createAction(
  '[Flows: Flow Configuration]: Update Configuration Success',
  props<{ res: QcResponse }>(),
);

export const UpdateConfigurationFailed = createAction(
  '[Flows: Flow Configuration]: Update Configuration Failed',
  props<{ error: HttpErrorResponse }>(),
);
